import { useState, useEffect, useMemo } from 'react';
import styles from './XboxPage.module.css';

import { Header } from '../../components/Header/Header';
import { DataInput } from '../../UI/DataInput/DataInput';
import { useDbUserId } from '../../hooks/useDbUserId';
import { useGetUserByIdQuery } from '../../store/api/user.api.js'
import { useUserDataBlurHandler } from '../../hooks/useUserDataBlurHandler.js';
import { useActivatePromoMutation } from '../../store/api/promo.api.js';
import { useAllItemsQuery } from '../../store/api/item.api.js';

import mainImg from '../../assets/xbox_main-img.svg';
import xboxIcon from '../../assets/xbox-icon.svg';
import emailIcon from '../../assets/email-icon.svg';
import passwordIcon from '../../assets/pass-icon.svg';
import plusIcon from '../../assets/inputPlus-icon.svg';
import checkboxIcon from '../../assets/checkbox-icon.svg';
import checkboxActiveIcon from '../../assets/checkboxActive-icon.svg';
import { BlueBtn } from '../../UI/BlueBtn/BlueBtn.jsx';
import { FormBtn } from '../../UI/FormBtn/FormBtn.jsx';


export const XboxPage = () => {
	const [haveAccount, setHaveAccount] = useState(false);
	const [activatePromo] = useActivatePromoMutation();
	const [activeSub, setActiveSub] = useState()

	const { tgId, dbUserId } = useDbUserId();
	const { data: userData, refetch: userRefetch } = useGetUserByIdQuery(tgId);
	const { data: subscriptions } = useAllItemsQuery({schema: 'xbox'})
	const [checkbox, setCheckbox] = useState(true);

	const [userDataState, setUserDataState] = useState({});
	const [promo, setPromo] = useState({
		id: null,
		value: '',
		disc: null,
		success: false,
		message: '',
	})
	const selectedSub = subscriptions?.find(sub => sub.id === activeSub);
	let finalPrice = (selectedSub?.price_disc || selectedSub?.price)
	if (promo.success) {
		finalPrice -= finalPrice / 100 * Number(promo.disc)
	}

	const orderData = {
		price: finalPrice,
		inShopInfo: {
			email: userDataState.email,
			login: userDataState.accountEmail,
			password: userDataState.accountPassword,
		},
		subscriptionId: selectedSub?.id,
		promoCodeId: promo.success ? promo.id : null,
	};

	useEffect(() => {
		sessionStorage.setItem('schema', 'xbox')
	}, [])

	useEffect(() => {
		if (userData) {
			setUserDataState({
				email: userData.email || '',
				accountEmail: userData.accountEmail || '',
				accountPassword: userData.accountPassword || '',
			});
		}
	}, [userData]);

	const { handleBlur } = useUserDataBlurHandler({
		checkbox,
		dbUserId,
		userRefetch,
		setUserDataState
	});

	const handleInputChange = (fieldName, value) => {
		setUserDataState(prevState => ({
			...prevState,
			[fieldName]: value,
		}));
	};

	const handlePromoBlur = async (value) => {
		if (value.length > 0) {
			const res = await activatePromo({ code: value })
			const resMess = res?.error ? res?.error.data.message : res?.data.message;
			setPromo({
				...promo,
				id: res?.data?.promoId || null,
				disc: res?.data?.disc || null,
				success: res?.error ? false : true,
				message: resMess
			})
		}
	}

	const forNewAcc = useMemo(() => {
		return subscriptions?.filter(sub => sub.type === 'forNewAcc') || [];
	}, [subscriptions]);

	const forPersonalAcc = useMemo(() => {
		return subscriptions?.filter(sub => sub.type === 'forPersonalAcc') || [];
	}, [subscriptions]);
	

	return (
		<div className='main' style={{marginBottom: 20}}>
			<div
				className={styles.itemImg}
				style={{
					backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.9), transparent), url(${mainImg})`
				}}
			>
				<Header />
			</div>
			<div className={styles.titleBlock}>
				<h1>GamePass Ultimate</h1>
				<img src={xboxIcon} alt="xboxIcon" />
			</div>
			<div className='form'>
				<FormBtn 
					text={'На мой личный аккаунт'}
					active={haveAccount}
					onClick={() => {
						setHaveAccount(true)
					}}
				/>
				<FormBtn 
					text={'На новый аккаунт'}
					active={!haveAccount}
					onClick={() => {
						setHaveAccount(false)
					}}
				/>
			</div>
			<div className={styles.subsContainer}>
				{(haveAccount ? forPersonalAcc : forNewAcc)?.map(sub => (
					<div
						className={`${styles.sub} ${activeSub === sub.id ? styles.activeSub : ''}`}
						onClick={() => setActiveSub(sub.id)}
						key={sub.id}
					>
						<p className={styles.time}>{sub.time} мес</p>
						<p className={styles.price}>{sub.price_disc || sub.price}₽</p>
					</div>
				))}
			</div>
			<div className='form'>
				{
					haveAccount ?
						<>
							<p>Данные аккаунта</p>
							<DataInput
								name="email"
								text={'E-mail'}
								type={'email'}
								img={emailIcon}
								value={userDataState.accountEmail}
								onChange={value => handleInputChange("accountEmail", value)}
								onBlur={value => handleBlur("accountEmail", value)}
							/>
							<DataInput
								name="password"
								text={'Пароль'}
								type={'password'}
								img={passwordIcon}
								value={userDataState.accountPassword}
								onChange={value => handleInputChange("accountPassword", value)}
								onBlur={value => handleBlur("accountPassword", value)}
							/>
							<DataInput
								name="email"
								text={'Почта для чека'}
								img={plusIcon}
								type={'email'}
								value={userDataState.email}
								onChange={value => handleInputChange("email", value)}
								onBlur={value => handleBlur("email", value)}
							/>
						</>
					:
					<>
						<p>Бот бесплатно создаст для вас новый аккаунт</p>
						<DataInput
							name="email"
							text={'Почта для чека'}
							img={plusIcon}
							type={'email'}
							value={userDataState.email}
							onChange={value => handleInputChange("email", value)}
							onBlur={value => handleBlur("email", value)}
						/>
					</>
				}
				<div className={styles.formLine}></div>
				<div className={styles.checkbox} onClick={() => setCheckbox(!checkbox)}>
					{checkbox ? (
						<img src={checkboxActiveIcon} alt="checkboxActiveIcon" />
					) : (
						<img src={checkboxIcon} alt="checkboxIcon" />
					)}
					<span>Запомнить данные</span>
				</div>
			</div>
			<div className="form">
				<p>Используйте промокод</p>
				{
					promo.message.length > 0 &&
						<p style={promo.success ? {marginTop: 10, color: "green"} : {marginTop: 10, color: "red"}}>{promo.message}</p>
				}
									
				<DataInput
					name="promo"
					text={'Промокод'}
					img={plusIcon}
					type={'text'}
					value={promo.value}
					onChange={value => setPromo({...promo, value})}
					onBlur={value => handlePromoBlur(value)}
				/>
			</div>
			<div className={styles.priceBlock}>
				{selectedSub && (
					<>
					{
						(selectedSub.price_disc || promo.success) &&
							<p className={styles.price_amount}>{selectedSub.price} ₽</p>
					}
						<h2 style={selectedSub.price_disc ? { color: '#FF0044' } : {}}>{finalPrice} ₽</h2>
					</>
					
				)}
			</div>
			<div className={styles.btn}>
				<BlueBtn
					type='pay'
					text='Купить'
					orderData={orderData}
					activeBtnOrder={haveAccount ? 1 : 2}
					disabled={!selectedSub && true}
				/>
			</div>
		</div>
	);
};
